import React from 'react';

import { ComposedElement, ElementSizeVariants, useColorToken } from '@bcp-nextgen-dx-component-factory/design-system';
import { Exclamation } from '@bcp-nextgen-dx-component-factory/icons-accolade';

export interface ExclamationIconProps {
	size?: ElementSizeVariants | undefined;
	iconFill?: string;
	width?: string;
	height?: string;
}

export const ExclamationIcon: React.FC<ExclamationIconProps> = ({
	size = 'big',
	iconFill = 'color_02.100',
	width = '80px',
	height = '80px',
}) => {
	const getColor = useColorToken();
	return (
		<ComposedElement
			containerShape="round"
			enableRadius={true}
			icon={{
				source: Exclamation.Fill,
				svgProps: {
					fill: getColor(iconFill),
					width: width,
					height: height,
				},
			}}
			container={{
				styles: {
					border: `3px solid ${getColor(iconFill)}`,
				},
			}}
			size={size}
		/>
	);
};
